import { UntypedFormBuilder } from "@angular/forms";
import { BaseFormBuilder } from "src/app/core/formBuilders/BaseFormBuilder";
import { Constants } from "src/app/shared/model/Constants";
import { PagingSearchCriteria } from "src/app/shared/model/PagingSearchCriteria";

export interface GetPortalMessagesForUserCriteria extends PagingSearchCriteria {
    portalUserId: string | null;
    onlyPriority?: boolean;
}


export class GetPortalMessagesForUserCriteriaFormBuilder extends BaseFormBuilder {

    static getForm(fb: UntypedFormBuilder, searchCriteria: GetPortalMessagesForUserCriteria)  {
  
      return fb.group(
        {
            portalUserId: [searchCriteria.portalUserId],
            onlyPriority: [!!searchCriteria.onlyPriority],
        }
      );
    }

    static initGetPortalMessagesForUserCriteria(): GetPortalMessagesForUserCriteria {
      return {
        portalUserId:null,
        onlyPriority: false,
        pageNumber: 1,
        rowsPerPage: 25,
        sortDirection: '',
        sortColumn: '',
        
      };
    }
  }
